import axios from "axios";
import { $api, API_URL } from "./interceptor";
import { adminsStore } from "views/store/useAdminsStore";

const SignIn = () => {
  const sendLoginRequest = async (email: string, password: string) => {
    const requestData = {
      email,
      password,
    };
    const response = await $api.post("api/admins/auth/login", requestData);

    const accessToken = response?.data?.tokens?.access;

    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      adminsStore.setState({currentRole: response?.data?.admin?.role})
    }
  };

  const logout = async () => {
    await $api.post("api/admins/auth/logout");
    localStorage.removeItem("accessToken");
    adminsStore.setState({currentRole: null})
  };

  const sendRefreshRequest = async () => {
    try {
      const storageAccessToken = localStorage.getItem("accessToken");

      if (!storageAccessToken) throw new Error("No access token");

      const resp = await axios.post(
        `${API_URL}api/admins/auth/refresh`,
        {},
        {
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json', 
          },
          withCredentials: true
        }
      );
      const accessToken = resp.data.access;
      localStorage.setItem("accessToken", accessToken);
      adminsStore.setState({currentRole: resp.data.role})
      return true;
    } catch (e) {
      localStorage.removeItem("accessToken");
      adminsStore.setState({currentRole: null})
      window.location.replace("/#/");
      throw e;
    }
  };

  return {
    sendLoginRequest,
    logout,
    sendRefreshRequest,
  };
};

export const signInService = SignIn();
